export default __webpack_public_path__ + "static/media/ERfaster.ecb4d752.svg";